import { render } from "./TheProfessionalInterConsultationView.vue?vue&type=template&id=6a3b6c05&scoped=true&ts=true"
import script from "./TheProfessionalInterConsultationView.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalInterConsultationView.vue?vue&type=script&lang=ts"

import "./TheProfessionalInterConsultationView.vue?vue&type=style&index=0&id=6a3b6c05&lang=scss&scoped=true"
import "./TheProfessionalInterConsultationView.vue?vue&type=style&index=1&id=6a3b6c05&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3b6c05"]])

export default __exports__